import {
    Select,
    DatePicker,
    Button
} from "antd";

import dayjs from "dayjs";

interface Props {

    status: string;

    setStatus: (
        value: string
    ) => void;

    fromDate: string;

    setFromDate: (
        value: string
    ) => void;

    toDate: string;

    setToDate: (
        value: string
    ) => void;

    onFilter: () => void;
}

export default function AdvancedSearch({

    status,
    setStatus,

    fromDate,
    setFromDate,

    toDate,
    setToDate,

    onFilter

}: Props) {

    return (
        <div className="bg-white p-4 rounded-lg border mt-3 dark:bg-[#141414] dark:border-gray-700 w-full">

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">

                {/* STATUS */}

                <Select
                    placeholder="Trạng thái đơn hàng"
                    className="w-full"

                    value={
                        status || undefined
                    }

                    onChange={setStatus}

                    options={[
                        {
                            label: "Ghi nợ",
                            value: "Ghi nợ",
                        },

                        {
                            label: "Hoàn thành",
                            value: "Hoàn thành",
                        },
                    ]}
                />

                {/* CHƯA SUPPORT */}

                <Select
                    disabled
                    placeholder="Khung giờ khuyến mãi"
                    className="w-full"
                />

                <Select
                    disabled
                    placeholder="Tất cả nền tảng"
                    className="w-full"
                />

                <Select
                    disabled
                    placeholder="Chọn loại đơn hàng..."
                    className="w-full"
                />

                {/* FROM DATE */}

                <DatePicker
                    placeholder="Từ ngày"
                    className="w-full"

                    value={
                        fromDate
                            ? dayjs(fromDate)
                            : null
                    }

                    onChange={(_, dateString) =>
                        setFromDate(
                            dateString as string
                        )
                    }
                />

                {/* TO DATE */}

                <DatePicker
                    placeholder="Đến ngày"
                    className="w-full"

                    value={
                        toDate
                            ? dayjs(toDate)
                            : null
                    }

                    onChange={(_, dateString) =>
                        setToDate(
                            dateString as string
                        )
                    }
                />

                {/* FILTER */}

                <Button
                    type="primary"

                    onClick={onFilter}

                    className="bg-green-500 col-span-1 md:col-span-1 xl:col-span-1"
                >
                    Lọc
                </Button>

                {/* RESET */}

                <Button
                    onClick={() => {

                        setStatus("");

                        setFromDate("");

                        setToDate("");

                        
                    }}

                    className="col-span-1 md:col-span-1 xl:col-span-1"
                >
                    Khôi phục
                </Button>

            </div>
        </div>
    );
}